/**
 * Глобальный UI-модуль: один общий snackbar и сигнал на открытие AuthModal.
 * Используется из любого места приложения (axios-перехватчики, миксины и т.д.)
 * без необходимости прокидывать ивенты через дерево компонентов.
 */
const state = {
  snackbar: {
    visible: false,
    text: '',
    color: 'success',
    timeout: 3000,
  },
  authModalOpen: false,
};

const mutations = {
  SHOW_SNACKBAR(state, payload) {
    state.snackbar = {
      visible: true,
      text: payload.text || '',
      color: payload.color || 'success',
      timeout: payload.timeout != null ? payload.timeout : 3000,
    };
  },
  HIDE_SNACKBAR(state) {
    state.snackbar = { ...state.snackbar, visible: false };
  },
  SET_AUTH_MODAL(state, value) {
    state.authModalOpen = !!value;
  },
};

const actions = {
  showSnackbar({ commit }, payload) {
    if (typeof payload === 'string') {
      commit('SHOW_SNACKBAR', { text: payload, color: 'success' });
      return;
    }
    commit('SHOW_SNACKBAR', payload || {});
  },
  showSuccess({ commit }, text) {
    commit('SHOW_SNACKBAR', { text, color: 'success' });
  },
  showError({ commit }, text) {
    commit('SHOW_SNACKBAR', { text, color: 'error', timeout: 4500 });
  },
  showInfo({ commit }, text) {
    commit('SHOW_SNACKBAR', { text, color: 'info' });
  },
  openAuthModal({ commit }) {
    commit('SET_AUTH_MODAL', true);
  },
  closeAuthModal({ commit }) {
    commit('SET_AUTH_MODAL', false);
  },
};

const getters = {
  snackbar: (state) => state.snackbar,
  authModalOpen: (state) => state.authModalOpen,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
